import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-cube-icon',
  standalone: true,
  templateUrl: './cube-icon.component.html',
  styleUrls: ['./cube-icon.component.scss']
})
export class CubeIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
